import EmptyResult from 'components/others/EmptyResult';
import TaskPayBlock from './TaskPayBlock';
import type { TaskPayReportRowType } from '@econtractor/types';

interface ReportByTaskDetailProps {
    users: TaskPayReportRowType[];
}

const ReportByTaskDetail = ({ users }: ReportByTaskDetailProps) => {
    if (!users.length) return <EmptyResult />;

    return (
        <div>
            {users.map((user) => (
                <TaskPayBlock key={user.userId} user={user} />
            ))}
        </div>
    );
};

export default ReportByTaskDetail;
